import FechamentoVendasCupomControleService from "@/services/FechamentoVendasCupomControleService";

export const fechamentoVendasCupomControle = {
  namespaced: true,
  state: {
    fechamentoVendasCupomControle: {},
  },
  actions: {
    getFechamentoVendasCupomControle({ commit }, payload) {
      return FechamentoVendasCupomControleService.GetFechamentoVendasCupomControle(
        payload
      ).then(
        (fechamentoVendasCupomControle) => {
          return Promise.resolve(fechamentoVendasCupomControle);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postFechamentoVendasCupomControle({ commit }, payload) {
      return FechamentoVendasCupomControleService.PostFechamentoVendasCupomControle(
        payload
      ).then(
        (fechamentoVendasCupomControle) => {
          return Promise.resolve(fechamentoVendasCupomControle);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putFechamentoVendasCupomControle({ commit }, payload) {
      return FechamentoVendasCupomControleService.PutFechamentoVendasCupomControle(
        payload
      ).then(
        (fechamentoVendasCupomControle) => {
          return Promise.resolve(fechamentoVendasCupomControle);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteFechamentoVendasCupomControle({ commit }, payload) {
      return FechamentoVendasCupomControleService.DeleteFechamentoVendasCupomControle(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getFechamentoVendasCupomControleOData({ commit }, payload) {
      return FechamentoVendasCupomControleService.GetFechamentoVendasCupomControleOData(
        payload
      ).then(
        (fechamentoVendasCupomControle) => {
          return Promise.resolve(fechamentoVendasCupomControle);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default fechamentoVendasCupomControle;
